import AppManagementPage from '.';

export default {
    appManagementPage: {
        path: '/app-management',
        title: 'App Management',
        auth: true,
        component: AppManagementPage,
        keyActiveTab: 'activeAppManagementTab',
    },
};
